import {
  highlightBracketedText,
  highlightUnderscoreText,
} from "src/utils/utils";
import { DynamicLink, SectionWrapper } from "src/components/shared";
import { FaArrowRightLong } from "react-icons/fa6";

type VerticalTab = {
  tabTitle: string;
  featureCardTitle: string;
  featureCardDescription: string;
  featureCardImage: { url: string,title:string };
  featureCardLinkText: string;
  featureCardLinkUrl: string;
  card1Title: string;
  card2Title: string;
  card3Title: string;
  card4Title: string;
  card1Description: string;
  card2Description: string;
  card3Description: string;
  card4Description: string;
  card1Image: { url: string };
  card2Image: { url: string };
  card3Image: { url: string };
  card4Image: { url: string };
};

type CapabilityComponentProps = {
  content?: {
    title: string;
    linkButton: {
      buttonText: string;
      buttonLink: string;
    };
    verticaltabListdescriptionJson: any;
    verticalTabsCollection: {
      items: VerticalTab[];
    };
  };
};

const VerticalTabEnterprise = ({ content }: CapabilityComponentProps) => {
  if (!content) return null;
  const { title, verticaltabListdescriptionJson } = content;
  const firstTab = content.verticalTabsCollection?.items[0];
  const description =
    verticaltabListdescriptionJson?.json?.content?.[0]?.content?.[0]?.value;
  
  const tabs = [
    {
      image: firstTab?.card2Image?.url,
      alt: "L1",
      title: firstTab?.card2Title,
      description: firstTab?.card2Description,
    },
    {
      image: firstTab?.card3Image?.url,
      alt: "L3",
      title: firstTab?.card3Title,
      description: firstTab?.card3Description,
    },
    {
      image: firstTab?.card4Image?.url,
      alt: "L5",
      title: firstTab?.card4Title,
      description: firstTab?.card4Description,
    },
  ];

  return (
    <SectionWrapper>
      <div className="vertical-tab-enterprise">
        <div className="header-container">
          <div className="title-container">
            <span
              className="highlight-bracket-text"
              dangerouslySetInnerHTML={{
                __html: highlightBracketedText(title ?? "", "bold"),
              }}
            />
          </div>
        </div>

        <div className="description-container">
          <div className="vertical-tab-eyebrow">{firstTab?.tabTitle}</div>
          <div className="vertical-tab-description">
            <p
              dangerouslySetInnerHTML={{
                __html: highlightUnderscoreText(description ?? ""),
              }}
              className="light"
              style={{ fontSize: "15.5px" }}
            />
          </div>
        </div>

        {/* Content area with tabs and image */}
        <div className="content-container">
          <div className="tabs-container">
            {tabs.map((tab, index) => (
              <div key={index} className="tab-item">
                <div className="tab-icon">
                  <img src={tab.image} alt={tab.alt} />
                </div>
                <div className="tab-content">
                  <h3 className="bold">{tab.title}</h3>
                  <p>{tab.description}</p>
                </div>
              </div>
            ))}
            <DynamicLink
              url={content?.linkButton?.buttonLink}
              className="btn-default-bdr"
            >
              <span>{content?.linkButton?.buttonText}</span>
              <FaArrowRightLong className="btn-icon" />
            </DynamicLink>
          </div>

          <div className="feature-image">
            <img
              src={firstTab?.featureCardImage?.url}
              alt={firstTab?.featureCardImage?.title}
              className="feature-img"
            />
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
};

export default VerticalTabEnterprise;
